import { useMemo } from 'react'
import { TokenListItem, TokenList as Tokens } from 'types/entities'

import { color } from 'theme'
import { Loader } from 'components/ui'

import { TokenRow } from './TokenRow'
import { TokenListWrap, TokenListLoader, TokenListContainer, TokenListLoaderText } from './Style'

type Props = {
  loading: boolean
  onToggle: VoidFunction
  filteredTokens: Tokens
  onSelect: (token: TokenListItem) => void
}

export function TokenList({ onSelect, onToggle, filteredTokens, loading }: Props) {
  const onSetToken = (token: TokenListItem) => {
    onSelect(token)
    onToggle()
  }

  const isFilteredTokens = useMemo(() => {
    return filteredTokens.length > 0
  }, [filteredTokens])

  return (
    <TokenListWrap>
      {loading && (
        <TokenListLoader>
          <Loader size={2.6} color={color.buttonBgSecond} />
          <TokenListLoaderText>Loading...</TokenListLoaderText>
        </TokenListLoader>
      )}
      {!loading && isFilteredTokens && (
        <TokenListContainer>
          {filteredTokens?.map((token) => (
            <TokenRow key={token.address} onSetToken={onSetToken} {...token} />
          ))}
        </TokenListContainer>
      )}
    </TokenListWrap>
  )
}
